import React from 'react';
import { Alert } from 'reactstrap';
import styles from './index.module.scss';
import { AlertProps } from './types';

const { successAlert } = styles;

export const AlertSuccess = (props: AlertProps) => <Alert data-testid={props.testId} color='success' className={successAlert}>{props.children}</Alert>;
